import React from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
    onClose: () => void;
}

const CardPaymentIframe: React.FC<Props> = ({ onClose }) => {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                maxWidth: 500,
                height: 500,
                borderRadius: 2,
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                overflow: "hidden",
                mx: "auto",
            }}
        >
            {/* Close Button */}
            <IconButton
                onClick={onClose}
                sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
            >
                <CloseIcon />
            </IconButton>

            {/* iFrame */}
            <iframe
                src="https://payment.url.ovde.stavi.com"
                title="Card Payment"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </Box>
    );
};

export default CardPaymentIframe;
